// extracted by mini-css-extract-plugin
module.exports = {"root":"segments_root__7_dwk","cardRoot":"segments_cardRoot__x8CQt","catList":"segments_catList__cuztj"};